import { removePrefixFromPP } from '../../saved-tables/utils'
import formatDate from '../../../utils/formatDate'

export const savedCollectionsColumns = [
  {
    name: 'name',
    label: 'Collection name',
    align: 'left',
    field: 'name',
    classes: 'capitalize',
    sortable: true,
    sortDirection: 'ASC',
    style: 'width: 35%; text-transform: capitalize'
  },
  {
    name: 'options',
    label: 'Options',
    align: 'left',
    field: ({ options } = {}) => options.length,
    classes: 'capitalize',
    sortable: true,
    sortDirection: 'DESC',
    style: 'width: 10%; text-transform: capitalize'
  },
  {
    name: 'components',
    label: 'Components',
    align: 'left',
    field: ({ components } = {}) => components.length,
    classes: 'capitalize',
    sortable: true,
    sortDirection: 'DESC',
    style: 'width: 10%; text-transform: capitalize'
  },
  {
    name: 'businessName',
    label: 'Product model',
    align: 'left',
    field: 'businessName',
    classes: 'capitalize',
    sortable: true,
    sortDirection: 'DESC',
    style: 'width: 10%; text-transform: capitalize'
  },
  {
    name: 'planningPeriodRange.to',
    align: 'left',
    label: 'Planning period',
    field: ({ planningPeriodRange } = {}) => removePrefixFromPP(planningPeriodRange.from),
    sortable: true,
    sortDirection: 'DESC',
    style: 'width: 10%; text-transform: capitalize'
  },
  {
    name: 'updatedAt',
    label: 'Last Edited',
    align: 'left',
    sortable: true,
    sortDirection: 'DESC',
    field: 'updatedAt',
    format: val => formatDate(val),
    style: 'width: 10%'
  },
  {
    name: 'actions',
    label: '',
    align: 'left',
    field: 'actions',
    style: 'width: 5%'
  },
  {
    name: 'send',
    label: '',
    align: 'left',
    field: 'send',
    style: 'width: 5%'
  }
]

export const SEARCH_STRING_PROVIDER = 'savedCollectionsSearchStringProvider'
